import '../styles/Questionnaire.scss'
const Questionnaire = () : JSX.Element => {

    return (
        <div className='container'>
            <h1 className="title">Questionnaire d'évaluation</h1>
            <p className="centeredMessage">À completer...</p>
        </div>
    )
}

export {
    Questionnaire
}